import React, { useState } from "react";
import { Formik, Form, FormikHelpers, FormikProps } from "formik";
import {
  SubmitButtonArea
} from "./Styled";
import { H1 } from "../../flowManager/optionsMenu/ComponentMenu/Styled";
import SaveButton from "../../../system/saveButton/SaveButton";

type BaseWidgetFormProps = {
  title: string;
  initialValues: any;
  onSubmit: (
    values: any,
    formikHelpers: FormikHelpers<any>
  ) => void | Promise<any>;
  renderForm: ((props: FormikProps<any>) => React.ReactNode) &
    (({ values }: FormikProps<any>) => JSX.Element);
};

const BaseWidgetForm: React.FunctionComponent<BaseWidgetFormProps> = ({
  initialValues,
  onSubmit,
  title,
  renderForm
}) => {
  const [isFormChanged, setIsFormChanged] = useState(false);

  const formChanged = () => {
    if (!isFormChanged) {
      setIsFormChanged(true);
    }
  };

  return (
    <div>
      <H1>{title}</H1>
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        render={values => (
          <Form onChange={formChanged}>
            <>
              {renderForm(values)}
              <SubmitButtonArea>
                <SaveButton disabled={!isFormChanged} />
              </SubmitButtonArea>
            </>
          </Form>
        )}
      />
    </div>
  );
};

export default BaseWidgetForm;
